import React from "react"
import StateContextProvider from "components/Context"

const wrapRootElement = ({ element, props }) => (
  <StateContextProvider>{element}</StateContextProvider>
)

export default wrapRootElement
